module.exports = __webpack_public_path__ + "media/site_templates/www.furnituredisposal.com.au/images/testimonials-97fdaba2337bc4fb220c1e0b371c2ce7.jpg";